import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import DownloadExcel from "../../../../Extra/DownloadExcel";

const TypeWisePWIData = ({ pwiData, loading, error, starDate, endDate }) => {
  const [corridor, setCorridor] = useState([]);
  const [nonCorridor, setNonCorridor] = useState([]);
  const [section, setSection] = useState([]);
  const [yard, setYard] = useState([]);
  const [machine, setMachine] = useState([]);
  const [other, setOther] = useState([]);
  const [burst, setBurst] = useState([]);
  const [notBurst, setNotBurst] = useState([]);
  const tableRef = useRef();
  useEffect(() => {
    if (!pwiData || pwiData.length === 0) {
      setCorridor([]);
      setNonCorridor([]);
      return;
    }

    const corridorData = [];
    const nonCorridorData = [];
    const sectionData = [];
    const yardData = [];
    const machineData = [];
    const otherData = [];
    const burstData = [];
    const notburstData = [];

    pwiData.forEach((item) => {
      if (item.Corridore?.trim() === "Corridor") {
        corridorData.push(item);
      } else if (item.Corridore?.trim() === "Non Corridor") {
        nonCorridorData.push(item);
      }

      if (item.Section_Yard?.trim() === "YARD") {
        yardData.push(item);
      } else {
        sectionData.push(item);
      }

      if (item.Type?.trim() === "MACHINE") {
        machineData.push(item);
      } else {
        otherData.push(item);
      }

      if (item.Burst?.trim() === "NOT BURST") {
        notburstData.push(item);
      } else {
        burstData.push(item);
      }
    });

    setCorridor(corridorData);
    setNonCorridor(nonCorridorData);
    setSection(sectionData);
    setYard(yardData);
    setMachine(machineData);
    setOther(otherData);
    setBurst(burstData);
    setNotBurst(notburstData);
  }, [pwiData]);

  const hhmmToMinutes = (hhmm) => {
    if (!hhmm || typeof hhmm !== "string") return 0;
    const [hours, minutes] = hhmm.split(":").map(Number);
    return hours * 60 + minutes;
  };

  const minutesToHHMM = (minutes) => {
    const h = Math.floor(minutes / 60);
    const m = minutes % 60;
    return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
  };

  const getSectionWiseTotals = (data) => {
    const sectionMap = {};

    data.forEach((item) => {
      const section = item.section?.trim() || "Unknown";

      if (!sectionMap[section]) {
        sectionMap[section] = {
          section,
          Agreed_Demand: 0,
          Engg_Demand: 0,
          Granted_Duration: 0,
          Availed: 0,
        };
      }

      sectionMap[section].Agreed_Demand += hhmmToMinutes(item.Agreed_Demand);
      sectionMap[section].Engg_Demand += hhmmToMinutes(item.Engg_Demand);
      sectionMap[section].Granted_Duration += hhmmToMinutes(
        item.Granted_Duration
      );
      sectionMap[section].Availed += hhmmToMinutes(item.Availed);
    });

    return Object.values(sectionMap).map((section) => ({
      section: section.section,
      Agreed_Demand: minutesToHHMM(section.Agreed_Demand),
      Engg_Demand: minutesToHHMM(section.Engg_Demand),
      Granted_Duration: minutesToHHMM(section.Granted_Duration),
      Availed: minutesToHHMM(section.Availed),
    }));
  };

  const renderTable = (data, title) => {
    const sectionTotals = getSectionWiseTotals(data);

    let totalAgreed = 0;
    let totalEngg = 0;
    let totalAvailedDuration = 0;
    let totalAvailed = 0;

    sectionTotals.forEach((section) => {
      totalAgreed += hhmmToMinutes(section.Agreed_Demand);
      totalEngg += hhmmToMinutes(section.Engg_Demand);
      totalAvailedDuration += hhmmToMinutes(section.Granted_Duration);
      totalAvailed += hhmmToMinutes(section.Availed);
      const sectionTotals = getSectionWiseTotals(data);
    });

    return (
      <div className="papaDiv  m-1" style={{ height: "100%" }}>
        <div className=" table-responsive   ">
          <table
            ref={tableRef}
            className="table table-hover table-striped  border loading"
            style={{ fontSize: "12px" }}
          >
            <thead className="table-dark">
              <tr>
                <th colSpan={6} className="fw-bolder fs-6">
                  {title} Wise Total
                </th>
              </tr>

              <tr>
                <th>Sr No.</th>
                <th>Section</th>
                <th>Agreed Demand</th>
                <th>Engg Demand</th>
                <th>Availed Duration</th>
                <th>Availed</th>
              </tr>
            </thead>
            <tbody>
              {sectionTotals.map((item, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{item.section}</td>
                  <td>{item.Agreed_Demand}</td>
                  <td>{item.Engg_Demand}</td>
                  <td>{item.Granted_Duration}</td>
                  <td>{item.Availed}</td>
                </tr>
              ))}
              <tr className="table-secondary fw-bold">
                <td colSpan={2}>Total</td>
                <td>{minutesToHHMM(totalAgreed)}</td>
                <td>{minutesToHHMM(totalEngg)}</td>
                <td>{minutesToHHMM(totalAvailedDuration)}</td>
                <td>{minutesToHHMM(totalAvailed)}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <DownloadExcel
          tableRef={tableRef}
          fileName={`PWI block SUmmery (Eng) - ${starDate}-${endDate}`}
        />
      </div>
    );
  };

  return (
    <div className=" papaDiv">
      <h5 className="p-1 text-white bg-dark">
        {" "}
        Block not availed summary form {starDate} to {endDate}
      </h5>
      {loading ? (
        <p>Loading data...</p>
      ) : error ? (
        <p style={{ color: "red" }}>Error fetching data.</p>
      ) : (
        <div>
          <div className="row   m-2">
            <div className="col-md-4">{renderTable(corridor, "Corridor")}</div>
            <div className="col-md-4">
              {renderTable(nonCorridor, "Non Corridor")}
            </div>
            <div className="col-md-4">{renderTable(section, "Section")}</div>
          </div>

          <div className="row   m-2">
            <div className="col-md-4 "> {renderTable(yard, "Yard")}</div>
            <div className="col-md-4 ">{renderTable(machine, "Machine")}</div>
            <div className="col-md-4 "> {renderTable(other, "Other")}</div>
          </div>

          <div className="row  m-2">
            <div className="col-md-6"> {renderTable(burst, "Burst")}</div>
            <div className="col-md-6">
              {" "}
              {renderTable(notBurst, "Not Burst")}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TypeWisePWIData;
